// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Nx6K","header":"ReportDetails_header__3_XRr","title":"ReportDetails_title__1LEVj","left":"ReportDetails_left__2AYty"};